import {Component, OnInit} from '@angular/core';
import {City} from '@models/city';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {Partner} from '@models/partner';
import {EMPTY_FAVORITE_LIST} from '@models/empty';
import {FormComponent} from '@components/popup/form/form.component';
import {MatDialog} from '@angular/material/dialog';
import {DetailComponent} from '@module/partners/detail/detail.component';

@Component({
    selector: 'app-partners',
    templateUrl: './partners.component.html',
    styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {

    partners: Partner[] = [];
    partnersBase: Partner[] = [];
    categories = [];
    currentCategories = ''
    loading = false;

    constructor(private http: HttpClient, private dialog: MatDialog) {
    }

    ngOnInit(): void {
        this.loading = true;
        this.http.get<Partner[]>(environment.apiUrl + 'app/partners').subscribe(c => {
            this.partners = c;
            this.partnersBase = c;
            this.loading = false;
            this.partners.forEach(p => {
                if (!this.categories.includes(p.categorie)) {
                    this.categories.push(p.categorie)
                }
            })
        });
    }

    openDetail(partner) {
        const dialogRef = this.dialog.open(DetailComponent, {
            width: '540px',
            maxWidth: '92%',
            maxHeight: '96vh',
            data: {
                partner: partner,
            },
        });
        dialogRef.afterClosed().subscribe(result => {
        });
    }

    filter() {
        var that = this;
        this.partners = this.partnersBase.filter(function(data) {
            if (that.currentCategories == "") {
                return true;
            }

            if (data.categorie == that.currentCategories) {
                return true;
            }
            return false;
        });
    }
}
